type UserPermissionsListItem = {
  id: string;
  property: string;
  label: string;
  description: string;
};

/**
 * The list of all permissions that can be granted to a user.
 */
export const permissionsList: Record<
  | 'profile'
  | 'billing'
  | 'settings'
  | 'createPositions'
  | 'editPositions'
  | 'applicationQuestions'
  | 'manageOnboarding'
  | 'defaultMessages',
  string
> = {
  profile: 'profile',
  billing: 'billing',
  settings: 'settings',
  createPositions: 'createPositions',
  editPositions: 'editPositions',
  manageOnboarding: 'manageOnboarding',
  applicationQuestions: 'applicationQuestions',
  defaultMessages: 'defaultMessages',
};

export const userPermissionsList: UserPermissionsListItem[] = [
  {
    id: '2',
    property: 'profile',
    label: 'Manage Company Profile',
    description:
      'Provides access to edit general company information and images.',
  },
  {
    id: '3',
    property: 'billing',
    label: 'Manage Payments/Billing',
    description:
      'Provides access to manage payment information and update subscriptions.',
  },
  {
    id: '7',
    property: 'settings',
    label: 'Manage Account Settings',
    description:
      'Provides access to manage declined application archive timeline, unnatended application archive timeline, and timezone.',
  },
  {
    id: '5',
    property: 'createPositions',
    label: 'Add New Positions',
    description: 'Provides access to add and customize new positions for hire.',
  },
  {
    id: '4',
    property: 'editPositions',
    label: 'Edit Position Information',
    description:
      'Provides access to edit hiring status, payrate, position description, and position type for access granted positions.',
  },
  {
    id: '1',
    property: 'applicationQuestions',
    label: 'Manage Application Questions',
    description:
      'Provides access to add, delete, and edit application questions for all positions.',
  },
  {
    id: '6',
    property: 'defaultMessages',
    label: 'Edit Default Response Messages',
    description:
      'Provides access to edit all company single-click responses - individual use case messages will still be editable in real time.',
  },
  {
    id: '8',
    property: 'manageOnboarding',
    label: 'Manage Onboarding',
    description:
      'Provide access of add, delete and edit onbarding packages, payroll partners.',
  },
];
